import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ItemActive = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M0 0V5V6H1H5V5H1V0H0Z" />
  </SvgIcon>
);

export default ItemActive;
